export default __webpack_public_path__ + "static/volunteer-77c2333e6f4914d446dd64f8d267fe80.svg";